import {Controller} from "@hotwired/stimulus"
import {debounce} from "lodash";

// Connects to data-controller="submit-form"

export default class extends Controller {
  static values = {
    waitForMs: {type: Number, default: 300}
  }
  static targets = ["form", "submittedFieldId"]

  connect() {
    this.throttleSubmit = debounce((e) => {
      this.submitForm(e);
    }, this.waitForMsValue);
  }

  submitForm(e) {
    if (this.hasSubmittedFieldIdTarget) {
      this.submittedFieldIdTarget.value = e.target.id;
    }

    if (this.formTarget.reportValidity()) {
      if (this.formTarget.requestSubmit) {
        this.formTarget.requestSubmit();
      } else {
        this.formTarget.submit();
      }
    }
  }
}
